/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url, camelcase */

import { compose, prop } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { sendAnalytics } from '@ezugi/analytics/sendAnalytics';
import { Dialog } from '@ezugi/primitives';

import { useIntl } from '../../../hooks/useIntl';
import {
  dialogActions,
  menuActions,
  socketActions,
  videoActions,
} from '../../../store/actions';
import { DISCONNECT_CLICK } from '../../../store/constants/analytics';
import { widgetsSelector } from '../../../store/selectors';
import { disconnectionClassName } from '../style.css';
import { reconnectButton, homeButton } from './buttons';

const { home } = menuActions;
const { socket } = socketActions;
const { dialog } = dialogActions;
const { video } = videoActions;

export const disconnectedForInactivityIntlKeys = {
  title: 'messages.disconnect_for_inactivity_title',
  message: 'messages.disconnect_for_inactivity_message',
  homeLabel: 'general.home',
  backLabel: 'general.go_back',
  reconnectLabel: 'general.reconnect',
};

const DisconnectedForInactivity = (props) => {
  const { title, message, homeLabel, backLabel, reconnectLabel } = useIntl({
    keys: disconnectedForInactivityIntlKeys,
  });
  const dispatch = useDispatch();
  const canGoHome = useSelector(compose(prop('home'), widgetsSelector));

  const removeDialog = () => dispatch(dialog.remove());
  const requestSocket = () => dispatch(socket.request());
  const requestHome = () => dispatch(home.request());
  const videoResume = () => dispatch(video.resume());

  return (
    <Dialog
      {...props}
      on={true}
    >
      <Dialog.Wrapper>
        <Dialog.Title>
          {title}
        </Dialog.Title>
        <Dialog.Description dangerouslySetInnerHTML={{ __html: message }} />
        <Dialog.Buttons>
          <Dialog.Button
            {...reconnectButton}
            className={disconnectionClassName}
            label={reconnectLabel}
            onClick={() => {
              removeDialog();
              requestSocket();
              videoResume();
              sendAnalytics({
                event: DISCONNECT_CLICK,
                click_type: 'reconnect',
              });
            }}
          />
          <Dialog.Button
            {...homeButton}
            className={disconnectionClassName}
            label={canGoHome ? homeLabel : backLabel}
            onClick={() => {
              removeDialog();
              canGoHome ? requestHome() : history.back();
              sendAnalytics({
                event: DISCONNECT_CLICK,
                click_type: canGoHome ? 'home' : 'back',
              });
            }}
          />
        </Dialog.Buttons>
      </Dialog.Wrapper>
    </Dialog>
  );
};

export default DisconnectedForInactivity;
